// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-4247728e]{background:#efefef;display:flex;width:100%;height:calc(100vh - 50px)}.main-content[data-v-4247728e]{width:50%;margin:auto;vertical-align:middle;align-self:center}.title[data-v-4247728e]{color:#6b6b6b;font-size:50px;margin-bottom:25px;font-weight:700;font-family:华文彩云;text-align:center}.brief[data-v-4247728e]{text-indent:40px;line-height:35px;font-size:20px}", ""]);
// Exports
module.exports = exports;
